import { SurveyForm } from "@/models/SurveyForm";
import {
  CheckBoxItemValue,
  RadioItemValue,
  SurveyItem
} from "@/models/SurveyItem";
import moment from "moment";

const serializeRadioItemValue = function(radio: RadioItemValue) {
  let res: string | string[];
  // テキストエリアが必須の項目を選択している場合
  if (radio.optionTextArea) {
    res = [];
    res.push(radio.selected);
    res.push(radio.optionTextArea.text);
  } else {
    res = radio.selected;
  }
  return res;
};

const serializeCheckBoxItemValue = function(checkbox: CheckBoxItemValue) {
  // テキストエリアが必須の項目を選択している場合
  if (checkbox.optionTextArea?.length) {
    const strings: (string | string[])[] = [];
    const tmp = checkbox.optionTextArea;
    const idsWithOptionTextArea = tmp.map(v => v.id);
    checkbox.selected.forEach(v => {
      const index = idsWithOptionTextArea.indexOf(v);
      if (index !== -1) {
        strings.push([v, tmp[index].text]);
      } else {
        strings.push(v);
      }
    });
    return strings;
  } else {
    // 1つのみを選択している場合
    if (checkbox.selected.length < 2) {
      return checkbox.selected[0];
    } else {
      // 複数選択している場合
      return checkbox.selected;
    }
  }
};

const serializeSurveyItem = function(surveyItem: SurveyItem) {
  switch (surveyItem.type) {
    case "rd":
      return serializeRadioItemValue(surveyItem.value as RadioItemValue);
    case "cb":
      return serializeCheckBoxItemValue(surveyItem.value as CheckBoxItemValue);
    default:
      return surveyItem.value as string;
  }
};

export const serializeSurveyForm = function(
  surveyForm: SurveyForm,
  passportid: string | (string | null)[]
) {
  const str: (string | (string | null)[] | (string | string[])[])[] = [];
  if (surveyForm.qrPrefix != null) {
    str.push(surveyForm.qrPrefix);
  }
  if (surveyForm.surveyId != null && surveyForm.hashCode != null) {
    str.push(surveyForm.surveyId + "_" + surveyForm.hashCode);
  }
  if (surveyForm.qrAnswerDate) {
    str.push(moment().format("YYYY/MM/DD HH:mm:ss"));
  } else {
    str.push("");
  }
  str.push(localStorage.getItem("__SelectedLangValue__") ?? "0");
  if (passportid != null) {
    str.push(passportid);
  }
  if (0 < surveyForm.surveyItems.length) {
    surveyForm.surveyItems.forEach(item => {
      str.push(serializeSurveyItem(item) ?? "");
    });
  }
  return JSON.stringify(str);
};
